
class PollResponseAnswer {
    pra_id: string | null | undefined
    pra_poll_question_id: string
    pra_poll_response_id: string | null | undefined
    pra_answer: string | null | undefined
    pra_score: number
    pra_poll_question_option_id: string | null | undefined
    pra_date: string | null | undefined
}

export default PollResponseAnswer;